;(function(){module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: {
    termsUrl: String,
    showTitle: {
      type: Boolean,
      "default": false
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"mini-rewards-terms"},[(showTitle)?_c('h4',[_v(_s(t('js.modules.rewards.mini_legal.title')))]):_e(),_v(" "),_c('p',[_c('span',[_v(_s(t('js.modules.rewards.mini_legal.content2')))]),_v(" "),_c('a',{attrs:{"href":termsUrl}},[_v(_s(t('js.modules.rewards.mini_legal.details2')))])])])}}
__vue__options__.staticRenderFns = []
